<template>
    <div class="content-wrapper">
        <div class="col-12 mb-primary">
            <div class="card card-with-shadow border-0 h-100">
                <div class="card-header p-primary bg-transparent">
                    <h5 class="card-title d-inline-block mb-0">{{ $t('create_companyprofile') }}</h5>
                    <div class="float-right">
                           how do other people see your profile? <a href="companyprofile/view" class="btn btn-primary btn-sm">View As</a>
                    </div>
                </div>
                <app-overlay-loader v-if="preloader"/>
                <div class="card-body">
                    <form ref="form" data-url="/crud" class="mb-0" :class="{'loading-opacity': preloader}">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="form-group">
                                        <label>{{ $t('upload_image') }}</label>
                                        <app-input type="custom-file-upload"
                                                :label="$t('upload_your_file')"
                                                v-model="inputs.custom_file"/>
                                        <small class="text-muted font-italic">
                                            {{ $t('recommended_custom_file_validation') }}
                                        </small>
                                </div>
                            </div>
                            <div class="col-md-10">
                                <div class="form-group">
                                    <label>{{ $t('name') }}</label>
                                    <app-input type="text"
                                            v-model="inputs.name"
                                            :required="true"
                                            :placeholder="$t('type_name')"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>{{ $t('about') }}</label>
                                    <app-input type="textarea"
                                            v-model="inputs.about" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('email') }}</label>
                                    <app-input type="email"
                                            v-model="inputs.email"
                                            :required="true" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('category') }}</label>
                                    <app-input type="text"
                                            v-model="inputs.category"
                                            :required="true"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('location') }}</label>
                                    <app-input type="text"
                                            v-model="inputs.location" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('contact_number') }}</label>
                                    <app-input type="tel-input"
                                            v-model="inputs.phone"
                                            :placeholder="$t('type_contact_number')"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group float-right">
                                    <button type="button"
                                        class="btn btn-primary btn-with-shadow"
                                        data-toggle="modal"
                                        @click="openAddEditModal">
                                    {{ $t('upload') }}
                                </button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>{{ $t('services') }}</label>
                                    <app-input type="textarea"
                                            v-model="inputs.service" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <p class="font-weight-bold">Upload Certificate</p>
                                <table class="table">
                                    <tr>
                                        <th>S.No</th>
                                        <th>Certificate</th>
                                        <th>Type</th>
                                        <th>Issue Date</th>
                                        <th>Expiry Date</th>
                                        <th>Action</th>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>Quality Management</td>
                                        <td>Supervisor</td>
                                        <td>2021-05-04 07:00</td>
                                        <td>2021-05-04 07:00</td>
                                        <td><button class="btn btn-primary btn-sm">view</button></td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>Quality Management</td>
                                        <td>Supervisor</td>
                                        <td>2021-05-04 07:00</td>
                                        <td>2021-05-04 07:00</td>
                                        <td><button class="btn btn-primary btn-sm">view</button></td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <p class="font-weight-bold">Work Experience</p>
                            <table class="table">
                                <tr>
                                    <th>S.No</th>
                                    <th>Project Title</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Action</th>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>Quality Management</td>
                                    <td>2021-05-04 07:00</td>
                                    <td>2021-05-04 07:00</td>
                                    <td><button class="btn btn-primary btn-sm">view</button></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <p class="font-weight-bold">Company History</p>
                        <p>A well-written company history can entice prospective customers</p>
                    </div>
                </div>
                <div class="mt-5 action-buttons">
                    <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                        {{ $t('submit')}}
                    </button>
                    <button type="submit" class="btn btn-secondary" @click.prevent="clear">
                        {{ $t('clear') }}
                    </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <company-upload
           v-if="isAddEditModalActive"
            :selected-url="selectedUrl"
            @close-modal="closeAddEditModal"
        />
    </div>
</template>

<script>
    import {FormMixin} from '../../../../../../core/mixins/form/FormMixin.js';

    export default {
        name: "FormGrid",
        mixins: [FormMixin],
        data() {
            return {
                isAddEditModalActive: false,
                preloader: false,
                inputs: {},
            }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                this.save(this.inputs);
            },

            afterSuccess(res) {
                this.$toastr.s(res.data.message);
            },
            afterFinalResponse() {
                this.preloader = false;
                this.inputs = {
                    gender: 'male',
                };
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.inputs = {};
                this.fieldStatus = {
                    isSubmit: false
                }
            },
            openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        /**
         * for close add edit modal
         */
        closeAddEditModal() {
            this.isAddEditModalActive = false;
        },
        }
    }
</script>